// Safely extract a human-readable message from an axios/FastAPI error.
// FastAPI 422 returns detail as an array of objects; 4xx business errors return a string.
export const getErrorMessage = (err, fallback = "Something went wrong.") => {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const first = detail[0];
    if (first?.msg) return first.msg;
    return fallback;
  }
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return fallback;
};
